import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';

import type { ChipFilterValue } from '@openx/types/chipFilters.ts';
import { XIcon } from '@phosphor-icons/react/X';

import { StyledStack } from './ListChipActiveFilters.styled.ts';
import type { ListChipFilterConfig } from './ListChipFilters.tsx';

type ListChipActiveFiltersProps<TFilters extends Record<string, ChipFilterValue>> = {
  activeFilters: string[];
  filters: TFilters;
  filtersConfig: Record<keyof TFilters, ListChipFilterConfig>;
  onDelete: (filterName: string) => void;
};

export const ListChipActiveFilters = <TFilters extends Record<string, ChipFilterValue>>({
  activeFilters,
  filters,
  filtersConfig,
  onDelete,
}: ListChipActiveFiltersProps<TFilters>) => {
  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <StyledStack>
      {activeFilters.map(filterName => {
        const filterValue = filters[filterName] || '';
        const filterConfig = filtersConfig[filterName];
        const filterOptions = filterConfig.options;

        return (
          <Chip
            deleteIcon={
              <IconButton size="large">
                <XIcon />
              </IconButton>
            }
            key={filterName}
            label={`${filterConfig.displayName}: ${filterOptions?.[filterValue]?.name || filterValue}`}
            onDelete={() => onDelete(filterName)}
          />
        );
      })}
    </StyledStack>
  );
};
